module.exports = __webpack_public_path__ + "img/con1-1y.1dbb77d8.png";